import { Item as DictionaryItem } from './generic';

export enum Type {
  array = 'array',
  int = 'int',
  bool = 'bool',
  text = 'text',
  date = 'date',
  longtext = 'longtext',
}

export enum Target {
  shortlist = 'shortlist',
  profile = 'profile',
  recruiter = 'recruiter',
  vacancy = 'vacancy',
}

export interface Definition extends DictionaryItem {
  type: Type;
  showInPublicWebsite: boolean;
  showInPanel: boolean;
}

export interface DefinitionDetails extends Definition {
  valuesAmount: number;
}

export interface CreatePayload {
  name: string;
  description: string | null;
  showInPanel: boolean;
  showInPublicWebsite: boolean;
  type: Type;
}

export interface UpdatePayload extends CreatePayload {
  id: number;
}

export interface Item {
  id?: number;
  type: Definition;
  value: string | number | boolean | Date | string[] | number[] | null;
}
